import { render, staticRenderFns } from "./student.vue?vue&type=template&id=223e73c8&scoped=true&"
import script from "./student.vue?vue&type=script&lang=ts&"
export * from "./student.vue?vue&type=script&lang=ts&"
import style0 from "./student.vue?vue&type=style&index=0&id=223e73c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e73c8",
  null
  
)

export default component.exports